import { useUI } from "providers/UIProvider"

import { Flex } from "@chakra-ui/react"

import Button from "components/UI/atoms/Button"
import Icon from "components/UI/atoms/Icon"
import { useLaundryContext } from "providers/LaundryProvider/LaundryProvider"

const LaundryFooter: React.FC<any> = ({ handleSubmit, handleDeny }) => {
  const { T } = useUI()
  const { createUpdateLaundryLoading } = useLaundryContext()

  return (
    <Flex
      mb={"30px"}
      gap={"30px"}
      mt={"70px"}
      width="100%"
      justifyContent="center"
    >
      <Button
        text={T("actions.confirm")}
        onClick={handleSubmit}
        variant="success"
        leftIcon={
          <Icon name="confirm" iconStyles={{ width: "30px", height: "30px" }} />
        }
        styles={{ width: "220px", height: "63px", fontSize: "m" }}
        _hover={{ backgroundColor: "#08BA36" }}
        isDisabled={createUpdateLaundryLoading}
        isLoading={createUpdateLaundryLoading}
      />
      <Button
        text={T("actions.deny")}
        onClick={handleDeny}
        variant="error"
        leftIcon={
          <Icon
            name="close_rounded"
            iconStyles={{ width: "30px", height: "30px" }}
          />
        }
        styles={{ width: "220px", height: "63px", fontSize: "m" }}
        _hover={{ backgroundColor: "#F30028" }}
        isDisabled={createUpdateLaundryLoading}
      />
    </Flex>
  )
}

export default LaundryFooter
